import { useEffect, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type AppBarActionsPortalProps = {
  children: ReactNode;
};

const AppBarActionsPortal = ({ children }: AppBarActionsPortalProps) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContainer(document.getElementById('appbar-actions'));
  }, []);

  const portalContent = useMemo(() => {
    if (!container) return null;
    return createPortal(children, container);
  }, [children, container]);

  return portalContent;
};

export default AppBarActionsPortal;
